<router-outlet></router-outlet>
<div class="loader-animation" *ngIf="!online">
  <svg-icon name="loader-animation" style="color: #8f9bba" class="input-icon"></svg-icon>
</div>
